export default "__VITE_ASSET__B555GPIE__"